import React from 'react';
import { arrowBackOutline } from 'ionicons/icons';

import { IonHeader, IonToolbar, IonButtons, IonButton, IonTitle, IonIcon, IonContent } from '@ionic/react';

// Components
import { MessageComponent } from '..';

export const ModalComponent = ({ message, urlImage, title, subtitle, children, closeModal, svg }) => {

    return (
        <>
            <IonHeader className="ion-no-border" translucent>

                <IonToolbar text-center mode="md" color='primary'>

                    {
                        closeModal ?  
                        <IonButtons slot="start">

                            <IonButtons slot="start">
                                <IonButton onClick={() => closeModal()}>
                                    <IonIcon slot="icon-only" icon={arrowBackOutline} />
                                </IonButton>
                            </IonButtons>

                        </IonButtons>
                        : 
                        null
                    }
                    <IonTitle className="ion-text-left ion-text-uppercase">{title}</IonTitle>

                </IonToolbar>

            </IonHeader>

            <IonContent className="ion-padding ion-text-center modal-content--compact">

                <MessageComponent
                    message={message}
                    subtitle={subtitle}
                    urlImage={urlImage}
                    svg={svg}
                >
                    {
                        children
                    }
                </MessageComponent>

            </IonContent>
        </>
    )
}